<template>
    <div class="animated fadeIn c-event-date-list">

        <table v-if="dataEvents.length > 0 && Core.Display.isMobile()" class="table">
            <tbody>
            <template v-for="group in dataEvents">
                <tr>
                    <td class="table-no-border" colspan="8">
                        <h5 class="mt-3">{{group.label}}</h5>
                    </td>
                </tr>
                <tr>
                    <th width="10%"></th>
                    <th width="10%">{{Core.Definition.getDefinition('Heures')}}</th>
                    <th>{{Core.Definition.getDefinition('Événement')}}</th>
                    <th width="5%"></th>
                    <th width="8%"></th>
                </tr>
                <tr v-if="group.events.length>0" v-for="event in group.events">
                    <td>
                        <div v-if="Core.Session.AuthUser.can('event_calendar_management_put') && displayEditMode">
                            <b-button @click="onEventClick(event, event.start)" class="btn btn-sm btn-light"><i class="fa fa-edit"></i></b-button>
                        </div>
                        <div v-else>
                            <b-button v-if="event.bookingIsEnabled == 1" @click="$emit('onBookClick',event)" :class="getVariant(event)" class="btn btn-sm"><i :class="getIcon(event)" class="fa"></i><template v-if="event.eventDateBooking !== undefined && event.eventDateBooking.status === Mantle.EventDateBooking.statusRegistered">&nbsp;{{Core.Definition.getDefinition('Réservé')}}</template></b-button>
                            <small v-if="event.finished == 1" class="text-muted">{{Core.Definition.getDefinition('Terminé')}}</small>
                        </div>
                    </td>
                    <td>
                        {{Mantle.Event.readableTime(event.start, event.end)}}
                    </td>
                    <td>
                        {{event.title}}<br/>
                        <div v-if="!Core.Validation.isEmpty(event.description)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayDescription'),'checkbox')" v-html="Mantle.Event.readableDescription(event.description)"></div>
                        <div v-if="!Core.Validation.isEmpty(event.eventDateUsers)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')">
                            {{Mantle.Event.readableResponsables(event.eventDateUsers)}}
                        </div>
                    </td>
                    <td>
                        <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMessage'),'checkbox')" @click="$emit('onMessagesClick',event)" class="btn btn-light btn-sm"><i class="fa fa-comment"></i> {{event.eventDateMessageCount}}</b-button>
                    </td>
                    <td>
                        <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayParticipant'),'checkbox')" @click="$emit('onBookingsClick',event)" class="btn btn-light btn-sm"><i class="fa fa-user"></i> {{Mantle.Event.readableBookingCount(event.eventDateBookingCount, event.max)}}</b-button>
                        <div v-if="(Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMinMax'),'checkbox') && !Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayParticipant'),'checkbox'))">
                            <i class="fa fa-user"></i> {{Mantle.Event.readableBookingCount(event.eventDateBookingCount, event.max)}}
                        </div>
                    </td>
                </tr>
                <tr v-if="group.events.length===0">
                    <td colspan="8">
                        <b-alert show variant="light">
                            {{Core.Definition.getDefinition('Aucun événement pour cette date')}}
                        </b-alert>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>

        <table v-if="dataEvents.length > 0 && !Core.Display.isMobile()" class="table">
            <tbody>
                <template v-for="group in dataEvents">
                    <tr>
                        <td class="table-no-border" colspan="8">
                            <h5 class="mt-3">{{group.label}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th width="10%"></th>
                        <th width="10%">{{Core.Definition.getDefinition('Heures')}}</th>
                        <th width="20%">{{Core.Definition.getDefinition('Événement')}}</th>
                        <th v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayDescription'),'checkbox')" width="20%">{{Core.Definition.getDefinition('Description')}}</th>
                        <th v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')" width="15%">{{Core.Definition.getDefinition('Responsables')}}</th>
                        <th v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayLocal'),'checkbox')" width="15%">{{Core.Definition.getDefinition('Local')}}</th>
                        <th v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMessage'),'checkbox')&&!Core.Session.AuthUser.can('event_calendar_management_put')" width="5%"></th>
                        <th width="8%"></th>
                    </tr>
                    <tr v-if="group.events.length>0" v-for="event in group.events">
                        <td>
                            <div v-if="Core.Session.AuthUser.can('event_calendar_management_put') && displayEditMode">
                                <b-button @click="onEventClick(event, event.start)" class="btn btn-sm btn-light"><i class="fa fa-edit"></i></b-button>
                            </div>
                            <div v-else>
                                <b-button v-if="event.bookingIsEnabled == 1" @click="$emit('onBookClick',event)" :class="getVariant(event)" class="btn btn-sm"><i :class="getIcon(event)" class="fa"></i><template v-if="event.eventDateBooking !== undefined && event.eventDateBooking.status === Mantle.EventDateBooking.statusRegistered">&nbsp;{{Core.Definition.getDefinition('Réservé')}}</template></b-button>
                                <small v-if="event.finished == 1" class="text-muted">{{Core.Definition.getDefinition('Terminé')}}</small>
                            </div>
                        </td>
                        <td>
                            {{Mantle.Event.readableTime(event.start, event.end)}}
                        </td>
                        <td>
                            {{event.title}}
                        </td>
                        <td v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayDescription'),'checkbox')">
                            <div v-html="Mantle.Event.readableDescription(event.description)"></div>
                        </td>
                        <td v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')">
                            {{Mantle.Event.readableResponsables(event.eventDateUsers)}}
                        </td>
                        <td v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayLocal'),'checkbox')">
                            {{Mantle.Event.readablePlace(event.local)}}
                        </td>
                        <td v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMessage'),'checkbox')&&!Core.Session.AuthUser.can('event_calendar_management_put')">
                            <b-button @click="$emit('onMessagesClick',event)" class="btn btn-light btn-sm"><i class="fa fa-comment"></i> {{event.eventDateMessageCount}}</b-button>
                        </td>
                        <td>
                            <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayParticipant'),'checkbox')&&!Core.Session.AuthUser.can('event_calendar_management_put')" @click="$emit('onBookingsClick',event)" class="btn btn-light btn-sm"><i class="fa fa-user"></i> {{Mantle.Event.readableBookingCount(event.eventDateBookingCount, event.max)}}</b-button>
                            <div v-if="(Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMinMax'),'checkbox')&&!Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayParticipant'),'checkbox'))">
                                <i class="fa fa-user"></i> {{Mantle.Event.readableBookingCount(event.eventDateBookingCount, event.max)}}
                            </div>
                        </td>
                    </tr>
                    <tr v-if="group.events.length===0">
                        <td colspan="8">
                            <b-alert show variant="light">
                                {{Core.Definition.getDefinition('Aucun événement pour cette date')}}
                            </b-alert>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    export default {
        name: 'EventList',
        components: {
        },
        props: {
            events: {
                type: Array,
                default: function() {
                    return []
                }
            },
            displayEditMode: {
                type: Boolean,
                default: false
            }
        },
        watch: {
        },
        mounted() {
            this.dataEvents = this.events
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataEvents: []
            }
        },
        methods: {
            onEventClick(event, eventStart) {

              this.$emit('onEventClick', event, eventStart)
            },
            clearEvents() {
                this.dataEvents = []
            },
            getIcon(event) {
                if (event.eventDateBooking !== undefined) {
                    switch(event.eventDateBooking.status) {
                        case Mantle.EventDateBooking.statusCancelled:
                            return 'fa-times'
                            break
                        case Mantle.EventDateBooking.statusWaiting:
                            return 'fa-hourglass-1'
                            break
                        default:
                            return 'fa-check'
                            break
                    }
                }
                return 'fa-user-plus'
            },
            getVariant(event) {
                if (event.eventDateBooking !== undefined) {
                    switch(event.eventDateBooking.status) {
                        case Mantle.EventDateBooking.statusCancelled:
                            return 'btn-danger'
                            break
                        case Mantle.EventDateBooking.statusWaiting:
                            return 'btn-warning'
                            break
                        default:
                            return 'btn-success'
                            break
                    }
                }
                return 'btn-primary'
            },
            getEvent(eventId) {
                for(let groupIndex in this.dataEvents) {
                    let events = this.dataEvents[groupIndex].events
                    let eventIndex = Core.Array.findIndexByKey(events, 'id', eventId)
                    if (eventIndex !== false) {
                        return events[eventIndex]
                    }
                }
            },
            updateEvent(event) {
                for(let groupIndex in this.dataEvents) {
                    let events = this.dataEvents[groupIndex].events
                    let eventIndex = Core.Array.findIndexByKey(events, 'id', event.id)
                    if (eventIndex !== false) {
                        let eventDates = Core.Array.newArray(events)
                        for(let eventDateIndex in eventDates) {
                            if(eventDates[eventDateIndex].id == event.id) {
                                eventDates[eventDateIndex] = event
                            }
                        }
                        this.dataEvents[groupIndex].events = []
                        this.dataEvents[groupIndex].events = eventDates
                    }
                }
            }
        }
    }
</script>

